export default function snakeize(obj) {
    if (!obj)
        return obj;
    if (typeof obj === 'string')
        return snakeCase(obj);
    if (obj._parts) {
        // FormData
        obj._parts = obj._parts.map((item) => [snakeCase(item[0]), item[1]]);
        return obj;
    }
    return walk(obj);
}
function walk(obj) {
    if (!obj || typeof obj !== 'object')
        return obj;
    if (isDate(obj) || isRegex(obj))
        return obj;
    if (Array.isArray(obj))
        return obj.map(walk);
    return Object.keys(obj).reduce((acc, key) => {
        const snake = snakeCase(key);
        acc[snake] = walk(obj[key]);
        return acc;
    }, {});
}
function snakeCase(str) {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
const isDate = (obj) => {
    return Object.prototype.toString.call(obj) === '[object Date]';
};
const isRegex = (obj) => {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
